import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=6b8a9f59&"
import script from "./ActionButtons.vue?vue&type=script&lang=ts&"
export * from "./ActionButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=6b8a9f59&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports